import closeIcon from 'assets/scheduling/close.svg';
import { useSelector } from 'react-redux';
import activePositionTabSelector from 'store/selectors/scheduleSelectors/activePositionTabSelector';
import { useScheduleActions } from 'store/reducers/scheduleSlice/scheduleSlice';
import getElementById from 'utils/getElementById';
import { ConflictsAndWarningsIcon, StyledTab, TabCloseButton, TabLabel } from './index.styled';
import { Wrapper } from './NewTabInput.styled';
import { useTranslation } from 'hooks/useTranslation';
import { MouseEvent } from 'react';

export const CONFLICTS_AND_WARNINGS_TAB = 'ConflictsAndWarnings';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ConflictsAndWarningsTab(props: any) {
  const ID = 'TAB_CONFLICTS_AND_WARNINGS';
  const { removePositionTab, setActiveTab } = useScheduleActions();
  const activeTab = useSelector(activePositionTabSelector);
  const { t } = useTranslation();

  const isActive = activeTab === CONFLICTS_AND_WARNINGS_TAB;

  function handleCloseTab(event: MouseEvent) {
    event.stopPropagation();
    removePositionTab(CONFLICTS_AND_WARNINGS_TAB);
  }

  function handleTabClick() {
    if (!isActive) {
      setActiveTab(CONFLICTS_AND_WARNINGS_TAB);

      const element = getElementById(ID);

      if (element && element.scrollIntoView && typeof element.scrollIntoView === 'function') {
        element.scrollIntoView(true);
      }
    }
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleTabClick();
    }
  }

  return (
    <Wrapper id={ID}>
      <StyledTab
        role="tab"
        aria-selected={isActive}
        isActive={isActive}
        tabIndex={0}
        onClick={handleTabClick}
        onKeyDown={handleKeyDown}
        {...props}
      >
        <ConflictsAndWarningsIcon />
        <TabLabel isActive={isActive}>{t('errors:CONFLICTS_WARNINGS_TAB_LABEL')}</TabLabel>

        <TabCloseButton data-testid="btn-tab-close" onClick={handleCloseTab}>
          <img alt="Close Icon" width={12} height={12} src={closeIcon} />
        </TabCloseButton>
      </StyledTab>
    </Wrapper>
  );
}
ConflictsAndWarningsTab.propTypes = {};

export default ConflictsAndWarningsTab;
